export default async function pleaseWait (state, appOptions) {
  const AdvisoryMessage = (await import(/* webpackChunkName: 'advisory-message' */ '@polleverywhere/toolkit/components/advisory_message')).default

  const view = new AdvisoryMessage({
    icon: 'info',
    subject: 'Please wait'
  })

  return view
}
